import { Navigate } from "react-router-dom";
import { useRole } from "../../contexts/RoleContext";
import { ShieldAlert } from "lucide-react";

export default function RequireRole({ children, fallback = "/dashboard" }) {
  const { isAdmin } = useRole();
  if (isAdmin) return children;
  return <AccessDenied fallback={fallback} />;
}

function AccessDenied({ fallback }) {
  // Short pause before redirect so the user sees the message
  return (
    <div
      data-testid="access-denied"
      className="min-h-[60vh] grid place-items-center px-6"
    >
      <div className="max-w-md text-center space-y-3">
        <div className="h-14 w-14 mx-auto rounded-2xl bg-rose-500/10 border border-rose-500/30 grid place-items-center">
          <ShieldAlert className="h-6 w-6 text-rose-300" />
        </div>
        <h1 className="font-display text-2xl font-semibold text-[var(--pl-text)]">
          Access Denied
        </h1>
        <p className="text-sm text-[var(--pl-text-muted)]">
          AdminLab is a platform-owner tool. Your workspace role does not include
          admin access.
        </p>
        <Navigate to={fallback} replace />
      </div>
    </div>
  );
}
